import { LockRewardStore } from "@/domains/lock-rewards/lock-reward-store"
import {
  ClaimEverythingByNftFormat,
  ClaimEverythingFormat,
} from "@/domains/lock-rewards/strategies/selection/lock-reward-selection-strategy"

/**
 * Converts an array of selected rewards to the contract format required for claiming
 */
export function rewardsToClaimEverythingFormat(selectedRewards: LockRewardStore[]): ClaimEverythingFormat {
  const bribes: string[] = []
  const bribeTokens: string[][] = []

  selectedRewards.forEach((reward) => {
    const bribeAddress = reward.bribeAddress.toViemAddress()

    if (!bribes.includes(bribeAddress)) {
      bribes.push(bribeAddress)
    }

    const bribeIndex = bribes.indexOf(bribeAddress)

    if (!bribeTokens[bribeIndex]) {
      bribeTokens[bribeIndex] = []
    }

    const tokenAddress = reward.token.address.toViemAddress()
    if (bribeTokens[bribeIndex]) {
      if (!bribeTokens[bribeIndex]!.includes(tokenAddress)) {
        // @ts-ignore
        bribeTokens[bribeIndex].push(tokenAddress)
      }
    }
  })

  return { bribes, bribeTokens }
}

/**
 * Converts an array of selected rewards to the contract format required for claiming
 */
export function rewardsToMultiNftClaimEverythingFormat(
  selectedRewards: LockRewardStore[],
): Array<ClaimEverythingByNftFormat> {
  const result: Array<ClaimEverythingByNftFormat> = []

  const selectedRewardsByNftId = selectedRewards.reduce(
    (acc, reward) => {
      if (!acc[reward.nftId]) {
        acc[reward.nftId] = []
      }
      acc[reward.nftId]!.push(reward)
      return acc
    },
    {} as Record<number, LockRewardStore[]>,
  )

  Object.entries(selectedRewardsByNftId).forEach(([nftId, rewards]) => {
    const { bribes, bribeTokens } = rewardsToClaimEverythingFormat(rewards)
    result.push({ nftId: Number(nftId), bribes, bribeTokens })
  })

  return result
}
